import { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';

import { useBulkUploads } from '../../../../shared/context';
import { EmptyUploads } from './empty-uploads.component';
import { QueuedSection } from './queued-section.component';
import { UploadingSection } from './uploading-section.component';

export const UploadsView = () => {
  const {
    state: { queued, uploading, rejected, totalCount },
  } = useBulkUploads();

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [queued, uploading, rejected]);

  if (totalCount === 0) {
    return <EmptyUploads />;
  }

  return (
    <>
      {uploading.length + rejected.length !== 0 && <UploadingSection />}

      {queued.length !== 0 && <QueuedSection />}

      <ReactTooltip place="top" effect="solid" id="path-tooltip" />
    </>
  );
};
